import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
  Box,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { convertToStandardFormat } from "@jumbo/utils/shamsiStandardFormat";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function GetReportDialog({ open, handleClose }) {
  const now = new Date();
  now.setHours(18, 0, 0, 0);

  const dateFormat = {
    date: now,
    gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
      .convert(gregorian, gregorian_en)
      .format(),
  };
  const classes = useStyles();
  const [fromDate, setFromDate] = useState(dateFormat);
  const [toDate, setToDate] = useState(dateFormat);

  const convertFromDate = (date, format = fromDate.format) => {
    let object = { date, format };
    setFromDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  const convertToDate = (date, format = toDate.format) => {
    let object = { date, format };
    setToDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  const handleGetReport = async () => {
    const downloadUrl = `${baseUrl}key/get/file?from=${convertToStandardFormat(
      fromDate.gregorian
    )}&to=${convertToStandardFormat(toDate.gregorian)}`;

    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",  
      });
 
      const contentDisposition = response.headers["content-disposition"];
      let filename = "default-filename.xlsx";  

      if (contentDisposition) { 
        const filenameRegex = /filename\*=UTF-8''([^;]+)/;
        const matches = filenameRegex.exec(contentDisposition);

        if (matches && matches[1]) { 
          filename = decodeURIComponent(matches[1]);
        } else { 
          const regularFilenameRegex = /filename="([^"]+)"/;
          const regularMatches = regularFilenameRegex.exec(contentDisposition);
          if (regularMatches && regularMatches[1]) {
            filename = regularMatches[1];
          }
        }
      }
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
 
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download the file", error);
    }
    handleClose();
    reset();
  };

  const reset = () => {
    setFromDate(dateFormat);
    setToDate(dateFormat);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          دریافت گزارش
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6}>
            <Box display={"flex"} alignItems="center">
              <CalendarTodayIcon fontSize="small" />
              <Box marginLeft={2}>
                <Typography>تاریخ شروع</Typography>
              </Box>
            </Box>

            <DatePicker
              containerClassName="custom-container"
              calendar={persian}
              locale={persian_fa}
              calendarPosition="top-right"
              value={fromDate.date}
              onChange={convertFromDate}
              format="HH:mm:ss   YYYY/MM/DD"
              plugins={[<TimePicker position="right" />]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display={"flex"} alignItems="center">
              <CalendarTodayIcon fontSize="small" />
              <Box marginLeft={2}>
                <Typography>تاریخ پایان</Typography>
              </Box>
            </Box>
            <DatePicker
              containerClassName="custom-container"
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              value={toDate.date}
              onChange={convertToDate}
              format="HH:mm:ss   YYYY/MM/DD"
              plugins={[<TimePicker position="right" />]}
            />
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleGetReport} color="primary">
          دریافت
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
